// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/root/code/tripairgo-admin/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelAuth0 from '/root/code/tripairgo-admin/src/models/auth.ts';
import ModelGlobal1 from '/root/code/tripairgo-admin/src/models/global.ts';
import ModelSetting2 from '/root/code/tripairgo-admin/src/models/setting.ts';
import ModelModel3 from '/root/code/tripairgo-admin/src/pages/_Order/model.ts';
import ModelModel4 from '/root/code/tripairgo-admin/src/pages/_TourSell/model.ts';
import ModelModel5 from '/root/code/tripairgo-admin/src/pages/Analytics/model.ts';
import ModelModel6 from '/root/code/tripairgo-admin/src/pages/Area/model.ts';
import ModelModel7 from '/root/code/tripairgo-admin/src/pages/Banner/model.ts';
import ModelModel8 from '/root/code/tripairgo-admin/src/pages/Blog/model.ts';
import ModelModel9 from '/root/code/tripairgo-admin/src/pages/ComboOrder/model.ts';
import ModelModel10 from '/root/code/tripairgo-admin/src/pages/Cost/model.ts';
import ModelModel11 from '/root/code/tripairgo-admin/src/pages/Customer/model.ts';
import ModelModel12 from '/root/code/tripairgo-admin/src/pages/Flight/Accounting/model.ts';
import ModelModel13 from '/root/code/tripairgo-admin/src/pages/Flight/Booking/model.ts';
import ModelModel14 from '/root/code/tripairgo-admin/src/pages/Flight/DepositTopUp/model.ts';
import ModelModel15 from '/root/code/tripairgo-admin/src/pages/Flight/Permission/model.ts';
import ModelModel16 from '/root/code/tripairgo-admin/src/pages/Flight/SignInSetting/model.ts';
import ModelModel17 from '/root/code/tripairgo-admin/src/pages/Flight/SubAgent/model.ts';
import ModelModel18 from '/root/code/tripairgo-admin/src/pages/Flight/User/model.ts';
import ModelModel19 from '/root/code/tripairgo-admin/src/pages/HotelOrder/model.ts';
import ModelModel20 from '/root/code/tripairgo-admin/src/pages/HotelService/model.ts';
import ModelModel21 from '/root/code/tripairgo-admin/src/pages/Menu/model.ts';
import ModelModel22 from '/root/code/tripairgo-admin/src/pages/Order/model.ts';
import ModelModel23 from '/root/code/tripairgo-admin/src/pages/Partner/model.ts';
import ModelModel24 from '/root/code/tripairgo-admin/src/pages/Place/model.ts';
import ModelModel25 from '/root/code/tripairgo-admin/src/pages/Policy/model.ts';
import ModelModel26 from '/root/code/tripairgo-admin/src/pages/Receipt/model.ts';
import ModelModel27 from '/root/code/tripairgo-admin/src/pages/Role/model.ts';
import ModelModel28 from '/root/code/tripairgo-admin/src/pages/Staff/model.ts';
import ModelModel29 from '/root/code/tripairgo-admin/src/pages/Supplier/model.ts';
import ModelModel30 from '/root/code/tripairgo-admin/src/pages/TicketService/model.ts';
import ModelModel31 from '/root/code/tripairgo-admin/src/pages/Tour/model.ts';
import ModelModel32 from '/root/code/tripairgo-admin/src/pages/TourGuide/model.ts';
import ModelModel33 from '/root/code/tripairgo-admin/src/pages/TourSell/model.ts';
import ModelModel34 from '/root/code/tripairgo-admin/src/pages/User/model.ts';
import ModelModel35 from '/root/code/tripairgo-admin/src/pages/VehicleService/model.ts';
import ModelModel36 from '/root/code/tripairgo-admin/src/pages/Visa/model.ts';
import ModelModel37 from '/root/code/tripairgo-admin/src/pages/VisaService/model.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'auth', ...ModelAuth0 });
app.model({ namespace: 'global', ...ModelGlobal1 });
app.model({ namespace: 'setting', ...ModelSetting2 });
app.model({ namespace: 'model', ...ModelModel3 });
app.model({ namespace: 'model', ...ModelModel4 });
app.model({ namespace: 'model', ...ModelModel5 });
app.model({ namespace: 'model', ...ModelModel6 });
app.model({ namespace: 'model', ...ModelModel7 });
app.model({ namespace: 'model', ...ModelModel8 });
app.model({ namespace: 'model', ...ModelModel9 });
app.model({ namespace: 'model', ...ModelModel10 });
app.model({ namespace: 'model', ...ModelModel11 });
app.model({ namespace: 'model', ...ModelModel12 });
app.model({ namespace: 'model', ...ModelModel13 });
app.model({ namespace: 'model', ...ModelModel14 });
app.model({ namespace: 'model', ...ModelModel15 });
app.model({ namespace: 'model', ...ModelModel16 });
app.model({ namespace: 'model', ...ModelModel17 });
app.model({ namespace: 'model', ...ModelModel18 });
app.model({ namespace: 'model', ...ModelModel19 });
app.model({ namespace: 'model', ...ModelModel20 });
app.model({ namespace: 'model', ...ModelModel21 });
app.model({ namespace: 'model', ...ModelModel22 });
app.model({ namespace: 'model', ...ModelModel23 });
app.model({ namespace: 'model', ...ModelModel24 });
app.model({ namespace: 'model', ...ModelModel25 });
app.model({ namespace: 'model', ...ModelModel26 });
app.model({ namespace: 'model', ...ModelModel27 });
app.model({ namespace: 'model', ...ModelModel28 });
app.model({ namespace: 'model', ...ModelModel29 });
app.model({ namespace: 'model', ...ModelModel30 });
app.model({ namespace: 'model', ...ModelModel31 });
app.model({ namespace: 'model', ...ModelModel32 });
app.model({ namespace: 'model', ...ModelModel33 });
app.model({ namespace: 'model', ...ModelModel34 });
app.model({ namespace: 'model', ...ModelModel35 });
app.model({ namespace: 'model', ...ModelModel36 });
app.model({ namespace: 'model', ...ModelModel37 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
